'use strict';

module.exports = {
  position: true,
  gfm: true,
  commonmark: false,
  footnotes: false,
  pedantic: false,
  blocks: require('./block-elements.json')
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/remark-parse/lib/defaults.js
// module id = 319
// module chunks = 0 15 16 17 18